var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkIconStarCircleLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.6556 11.9835C23.0687 10.7286 24.8801 10.724 25.2995 11.9771L27.6995 19.1483L35.4038 19.1285C36.7504 19.1246 37.3147 20.8116 36.2275 21.5898L30.0064 26.0412L32.4062 33.2123C32.8259 34.4658 31.362 35.5129 30.2709 34.7398L24.0264 30.3201L17.8054 34.7714C16.7181 35.5496 15.2488 34.5103 15.662 33.2552L18.0239 26.0716L11.7788 21.652C10.6873 20.8799 11.2426 19.1904 12.5891 19.1865L20.2936 19.1673L22.6556 11.9835Z"
  })));
}
export default SvgBookmarkIconStarCircleLarge;